if (!customElements.get('pdp-info-drawer')) {
  class PdpInfoDrawer extends HTMLElement {
    constructor() {
      super();
      this._onTriggerClick = this._onTriggerClick.bind(this);
      this._onCloseClick = this._onCloseClick.bind(this);
      this._onDrawerOpen = this._onDrawerOpen.bind(this);
      this._onDrawerClose = this._onDrawerClose.bind(this);
    }

    connectedCallback() {
      this.trigger = this.querySelector('[data-drawer-trigger]');
      this.drawer = this.querySelector('theme-drawer');
      this.closeButton = this.querySelector('[data-drawer-close]');

      // `position: sticky` on the info column (`.main-product__info--sticky`) always
      // creates a stacking context, regardless of z-index. That traps the fixed,
      // high-z-index <theme-drawer> inside it, so the sticky header (also fixed,
      // lower z-index) paints on top. Portal the drawer to <body> so it escapes
      // that stacking context and stacks at the root, same as cart/nav/search's
      // drawers. The trigger stays put; aria-controls/getElementById still resolve
      // the drawer by id regardless of where it lives in the DOM.
      if (this.drawer && this.drawer.parentNode !== document.body) {
        document.body.appendChild(this.drawer);
      }

      this._abortController = new AbortController();
      const signal = this._abortController.signal;

      this.trigger?.addEventListener('click', this._onTriggerClick, { signal });
      this.closeButton?.addEventListener('click', this._onCloseClick, { signal });

      this._unsubscribeOpen = theme.pubsub?.subscribe(theme.pubsub.events.DRAWER_OPEN, this._onDrawerOpen);
      this._unsubscribeClose = theme.pubsub?.subscribe(theme.pubsub.events.DRAWER_CLOSE, this._onDrawerClose);
    }

    disconnectedCallback() {
      this._abortController?.abort();
      this._unsubscribeOpen?.();
      this._unsubscribeClose?.();
      this.drawer?.remove();
    }

    _materialise() {
      const template = this.drawer?.querySelector('template[data-drawer-lazy-content]');
      template?.replaceWith(template.content);
    }

    _onTriggerClick() {
      this._materialise();
      this.drawer?.open();
    }

    _onCloseClick() {
      this.drawer?.close();
    }

    _onDrawerOpen(data) {
      if (!this.drawer || data.id !== this.drawer.id) return;
      this._materialise();
      this.trigger?.setAttribute('aria-expanded', 'true');
    }

    _onDrawerClose(data) {
      if (!this.drawer || data.id !== this.drawer.id) return;
      this.trigger?.setAttribute('aria-expanded', 'false');
    }
  }

  customElements.define('pdp-info-drawer', PdpInfoDrawer);
}
